// ==================== FILE: src/components/FlowBuilder/utils/templateExamples.js ====================
export const templateExamples = {
  ecommerce: [
    {
      id: 'cart-recovery',
      name: 'Abandoned Cart Recovery',
      description: 'Recover abandoned carts with follow-up messages',
      category: 'ecommerce',
    },
    {
      id: 'product-view',
      name: 'Product View Reminder',
      description: 'Remind users about viewed products',
      category: 'ecommerce',
    },
    {
      id: 'wishlist-followup',
      name: 'Wishlist Follow-Up',
      description: 'Follow up on wishlist items with offers',
      category: 'ecommerce',
    },
  ],
  marketing: [
    {
      id: 'promo-redemption',
      name: 'Promo Code Redemption Flow',
      description: 'Track promo code usage and send reminders',
      category: 'marketing',
    },
    {
      id: 'email-reengagement',
      name: 'Email Re-engagement',
      description: "Re-engage users who didn't open emails",
      category: 'marketing',
    },
  ],
  banking: [
    {
      id: 'loan-followup',
      name: 'Loan Offer Follow-Up',
      description: 'Follow up on loan applications',
      category: 'banking',
    },
    {
      id: 'kyc-reminder',
      name: 'KYC Reminder',
      description: 'Remind users to complete KYC',
      category: 'banking',
    },
  ],
  saas: [
    {
      id: 'trial-conversion',
      name: 'Trial Conversion Flow',
      description: 'Convert trial users to paid',
      category: 'saas',
    },
  ],
  telecom: [
    {
      id: 'sim-activation',
      name: 'SIM Activation Reminder',
      description: 'Remind users to activate SIM',
      category: 'telecom',
    },
  ],
  ai: [
    {
      id: 'low-engagement',
      name: 'Low Engagement Reactivation',
      description: 'Reactivate low-engagement users',
      category: 'ai',
    },
  ],
};